export default __webpack_public_path__ + "40c898caa52cec86e3b189e670a2c8f2.png";